import React, { Component } from "react";

export default class MissingRight extends Component {
  render() {
    return <div>You have no right for that action!</div>;
  }
}
